(function($) {
	'use strict';
	$.widget('msv.cookieConsent', {
		el: {},
		options: {},
		_create: function() {
			var self = this;
			this.options = {
				"palette": {
					"popup": {
						"background": "#00B1D7",
						"text": "#fff"
					},
					"button": {
						"background": "transparent",
						"text": "#fff",
						"border": "#fff"
					}
				},
				"content": {
					"message": this.element.data("consent-message"),
					"dismiss": this.element.data("consent-dismiss"),
					"link": this.element.data("consent-link"),
					"href": this.element.data("consent-href")
				}
			}
		},
		_init: function() {
			var self = this;
			window.addEventListener("load", function() {
				window.cookieconsent.initialise(self.options)
			});
		}
	});
})(jQuery);